import { render } from "./AddLivraison.vue?vue&type=template&id=f0c3c72e&scoped=true&ts=true"
import script from "./AddLivraison.vue?vue&type=script&lang=ts"
export * from "./AddLivraison.vue?vue&type=script&lang=ts"

import "./AddLivraison.vue?vue&type=style&index=0&id=f0c3c72e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0c3c72e"]])

export default __exports__